import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

export function VinconexLogo({ variant = "wordmark", className = "", to = "/" }) {
  const src = variant === "full" ? BRAND.logo : variant === "mark" ? BRAND.mark : BRAND.wordmark;
  const img = <img src={src} alt={BRAND.name} data-testid={`vinconex-logo-${variant}`} className={className} />;
  return to ? <Link to={to} className="inline-flex items-center">{img}</Link> : img;
}

export function PoweredBy({ light = false, className = "" }) {
  return (
    <div
      data-testid="powered-by-vinconex"
      className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] font-mono-tech font-semibold ${
        light ? "text-gray-500" : "text-slate-500"
      } ${className}`}
    >
      Powered by
      <img src={BRAND.mark} alt="" className="h-3.5 w-auto" />
      <span className={light ? "text-gray-800" : "text-slate-300"}>{BRAND.name}</span>
    </div>
  );
}
